<div class="links" *ngIf="user">
  <a routerLink="/merchants" routerLinkActive="active">Merchants</a>
  <a routerLink="/reports" routerLinkActive="active">Reports</a>
</div>
